import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { Session } from './session';
import { Utilisateur } from '../utilisateur/utilisateur';
import { PostLoginBody } from './post_login_body.models';

@Injectable()
export class AuthService {
    private redirectUrl: string = '/';
    private loginUrl: string = '/login';

    constructor(
        private http: HttpClient,
        private router: Router) {
    }

    isUserAuthenticated(username: string, password: string, database: string): Observable<boolean> {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          'Authorization': "Basic " + btoa(`${username}:${password}`)
        })
      };
      var body = new PostLoginBody(database, 2);

      return this.http.post<any>(`/api/Authentification/Login`, body, httpOptions)
            .pipe(map(body => {
                if (body.CleSessionStr != null) {
                    let cleSession = body.CleSessionStr;
                    let item = { Username: username, CleSession: cleSession, Database: database };
                    let loginItem = { Username: username, Database: database };

                    localStorage.setItem( 'gapSession', JSON.stringify(item) );
                    localStorage.setItem( 'gapLoginInfo', JSON.stringify(loginItem));
                    this.setInfoUtilisateur();
                }
                return this.isUserLoggedIn();
            }))
    }
    isUserLoggedIn(): boolean {
        let user = JSON.parse(localStorage.getItem('gapSession'));
        return user && user.CleSession != "";
    }
    getCleSession(): string {
      let user = JSON.parse(localStorage.getItem('gapSession'));
      if (user != null) return user.CleSession;
      else return "";
    }
    getCleUser(): number {
      let user = JSON.parse(localStorage.getItem('gapSession'));
      return user.Cle;
    }
    getRedirectUrl(): string {
        return this.redirectUrl;
    }
    setRedirectUrl(url: string): void {
        this.redirectUrl = url;
    }
    getLoginUrl(): string {
        return this.loginUrl;
    }
    getLoggedInUser(): Session {
        return JSON.parse(localStorage.getItem('gapSession'));
    }
    getLoginInfo(): Session{

      if(localStorage.getItem('gapLoginInfo') === null){
        return null;
      }
      else{
        return JSON.parse(localStorage.getItem('gapLoginInfo'));
      }
    }
    logoutUser(withRedirect: boolean): void{
        localStorage.removeItem('gapSession');
        if (withRedirect == true) {
            console.log('redirect');
            var auth = this;
            setTimeout(function(){
                auth.router.navigateByUrl(auth.getLoginUrl());
            },250);

        };
    }
    setInfoUtilisateur(): void {
        this.http.get<any>(`/api/Utilisateur/CleUtilisateur`)
            .subscribe(body => {
                if (body.Cle != null) {
                  let session = JSON.parse(localStorage.getItem('gapSession'));
                  session.Cle = body.Cle;
                  localStorage.setItem( 'gapSession', JSON.stringify(session) );

                  this.http.get<any>(`/api/Utilisateur/Signaletique/${session.Cle}`)
                    .subscribe(resp => {
                        let utilisateur = new Utilisateur();
                        utilisateur.Cle = resp.Cle;
                        utilisateur.Nom = resp.Nom;
                        utilisateur.Prenom = resp.Prenom;
                        utilisateur.Login = resp.Login;

                        localStorage.setItem( 'gapUtilisateur', JSON.stringify(utilisateur) );
                    });
                };
            });
    }
}
